module.exports = __webpack_public_path__ + "img/bg-small.32023fc8.png";